<template>
    <AppLayout title="Clientes Globales">
        <div>
            <div class="clientes bg-white">
                <Toast />
                <Breadcrumb
                    name="Clientes Globales"
                    routeName="clientes_globales"
                    page="Todos los Clientes Globales"
                />

                <DataTable
                    :value="clients"
                    responsiveLayout="scroll"
                    :paginator="true"
                    dataKey="id"
                    :filters="filters"
                    :rows="10"
                    :rowsPerPageOptions="[10, 20, 50]"
                >
                    <template #header>
                        <div
                            class="flex flex-col-reverse items-end lg:justify-between lg:flex-row"
                        >
                            <span class="block mt-2 p-input-icon-left">
                                <i class="pi pi-search" />
                                <InputText
                                    placeholder="Buscar cliente..."
                                    v-model="filters['global'].value"
                                    class="p-inputtext-sm"
                                />
                            </span>
                            <Link href="/clientes_globales/create">
                                <Button>
                                    <div class="flex items-center space-x-2">
                                        <Icon><Plus /></Icon>
                                        <span> Crear Cliente Global </span>
                                    </div>
                                </Button>
                            </Link>
                        </div>
                    </template>
                    <Column field="nombre" header="Nombre"></Column>
                    <Column field="descripcion" header="Descripción"></Column>
                    <Column field="razon_social" header="Razon Social"></Column>
                    <Column field="contacto" header="Contacto"></Column>
                    <Column field="telefono" header="Teléfono"></Column>
                    <Column field="email" header="Email"></Column>
                    <Column header="Acciones">
                        <template #body="slotProps">
                            <div class="flex space-x-2">
                                <Link
                                    :href="
                                        '/clientes_globales/' +
                                        slotProps.data.id +
                                        '/edit'
                                    "
                                >
                                    <Button>
                                        <Icon><PencilAlt /></Icon>
                                    </Button>
                                </Link>
                                <Button
                                    variant="destructive"
                                    @click="confirmDelete(slotProps.data)"
                                >
                                    <Icon><Trash /></Icon>
                                </Button>
                            </div>
                        </template>
                    </Column>
                </DataTable>
            </div>
        </div>
        <!-- Delete client dialog -->
        <Dialog
            v-model:visible="deleteClientDialog"
            :style="{ width: '450px' }"
            header="Confirmar"
            :modal="true"
        >
            <div class="flex items-center justify-center" style="height: 80px">
                <i
                    class="pi pi-exclamation-triangle mr-3"
                    style="font-size: 2rem"
                />
                <span v-if="client">
                    ¿Seguro que deseas eliminar a <b>{{ client.nombre }}</b
                    >?
                </span>
            </div>
            <template #footer>
                <div class="flex justify-end space-x-2">
                    <Button @click="deleteClientDialog = false"
                        >Cancelar</Button
                    >
                    <Button variant="destructive" @click="deleteClient"
                        >Eliminar</Button
                    >
                </div>
            </template>
        </Dialog>
    </AppLayout>
</template>

<script>
import { FilterMatchMode } from "primevue/api";
import { Inertia } from "@inertiajs/inertia";
import AppLayout from "@/Layouts/AppLayout.vue";
import Breadcrumb from "@/shared/Breadcrumb.vue";
import Button from "@/shared/Button.vue";
import { Icon } from "@vicons/utils";
import { Plus, PencilAlt, Trash } from "@vicons/fa";
import { Link } from "@inertiajs/inertia-vue3";

export default {
    components: {
        AppLayout,
        Breadcrumb,
        Icon,
        Plus,
        Link,
        Button,
        PencilAlt,
        Trash,
    },
    props: {
        // propiedades inyectadas via laravel-inertia
        clientes_globales: Array,
    },
    data() {
        return {
            deleteClientDialog: false,
            client: {},
            clients: [],
            isLoading: false,
            isEdit: false,
            filters: {},
        };
    },
    created() {
        this.clients = [...this.clientes_globales];
        this.initFilters();
    },
    methods: {
        hideDialog() {
            this.clientDialog = false;
            this.isLoading = false;
            this.isEdit = false;
        },
        reloadProps() {
            Inertia.reload({ only: ["clientes_globales"] });
            this.clients = [...this.clientes_globales];
        },
        initFilters() {
            this.filters = {
                global: { value: null, matchMode: FilterMatchMode.CONTAINS },
            };
        },
        confirmDelete(client) {
            this.client = client;
            this.deleteClientDialog = true;
        },
        deleteClient() {
            this.deleteClientDialog = false;
            this.$inertia
                .form()
                .delete(`/clientes_globales/${this.client.id}`, {
                    onSuccess: () => {
                        this.$toast.add({
                            severity: "success",
                            summary: "Exito",
                            detail: "Cliente eliminado",
                            life: 3000,
                        });
                        this.reloadProps();
                    },
                    onError: (errors) => {
                        this.$toast.add({
                            severity: "error",
                            summary: "Ha ocurrido un error",
                            life: 3000,
                        });
                    },
                });
        },
    },
};
</script>

<style>
.v-card-header {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
}
.v-danger-icon {
    color: #e30032;
}

.clientes .table-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.clientes .p-datatable-header {
    background: white;
    border-top: none;
}
.clientes .p-inputtext-sm {
    border-radius: 0.5rem;
}

.clientes .p-datatable-header {
    background: white;
    border-top: none;
}
.clientes .p-inputtext-sm {
    border-radius: 0.5rem;
}
.clientes .p-inputtext-sm:hover {
    border-color: #2e5f98;
}
.clientes .p-inputtext-sm:enabled:focus {
    border-color: #2e5f98;
    box-shadow: 0 0 0 1px #2e5f98;
}
.clientes .p-paginator .p-paginator-pages .p-paginator-page.p-highlight:focus {
    border-color: #2e5f98;
}
.clientes .p-paginator .p-paginator-pages .p-paginator-page.p-highlight {
    border-color: #2e5f98;
}

.clientes .p-paginator .p-paginator-pages .p-paginator-page.p-highlight {
    color: #2e5f98;
}
.clientes .p-link:focus {
    box-shadow: 0 0 0 1px #2e5f98;
}

.clientes .p-dropdown-panel .p-dropdown-items .p-dropdown-item.p-highlight {
    color: #2e5f98;
}

.clientes .p-dropdown:not(.p-disabled).p-focus {
    box-shadow: 0 0 0 1px #2e5f98;
    border-color: #2e5f98;
}

.clientes li.p-dropdown-item.p-highlight,
.p-dropdown-panel .p-dropdown-items .p-dropdown-item.p-highlight {
    color: #2e5f98;
}
</style>
